import { Box, FormLabel, Input, useToast, Select,ButtonGroup,Button} from "@chakra-ui/react"
import { useState,useEffect } from "react"
import { getGovedoById } from "../../util/apiGovedo";
import { userReadOnly } from "../../util/grunt";
import { MdSaveAlt,MdCancel } from "react-icons/md";
import { getPasmine } from "../../util/apiPasmina";
export default function GovedoView({_idgoveda,size='xs',_readonly=true, onSave, onClose,_showSaveClose=false}) {

  const [govedo,setGovedo]=useState();
  const [pasmine,setPasmine]=useState([]);
  const [DataFetched,setDataFetched]=useState(false);
  const toast=useToast();




  useEffect(() => {
    let err=false;
   const fetchData=async ()=>{
    try {
      const _res=await getGovedoById(_idgoveda);
      const _resPasmine=await getPasmine();
      if (_res.status===200 & _resPasmine.status===200) {
          if (_res.res.length>0) {
            setGovedo(_res.res[0]);  
            setPasmine(_resPasmine.res);
            setDataFetched(true);
          } else {
            setGovedo([]);  
            setDataFetched(false);
          }
          
      } else {
        throw new Error(_res.message);
      }

    } catch (error) {
      err=true;
      toast({
        title:"Greška kod dohvata podataka.",
        status:"error",
        description:error.message,
        isClosable:true,
        duration:2000,
        position:"top-right",
    });
    } finally {
      if (err) {
        setDataFetched(false);  
      }
      
    }
   }
  
   fetchData();
   
  }, [])
  
  const showSaveClose=()=>{
    if (_showSaveClose) {
      return <Box>
        <ButtonGroup gap={'1rem'} mr={'10rem'}>
            
            <Button isDisabled={userReadOnly()} rightIcon={<MdSaveAlt/>} colorScheme={'grunt2'} onClick={()=>{onSave(govedo)}} size={size}>Spremi</Button>
            <Button colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={size} onClick={onClose}>Odustani</Button>
            
            
        </ButtonGroup>
      </Box>
    }
  }
  

  const onValueChange=(event)=>{
    //const _s=event.target.value.toUpperCase();
    const _s=event.target.value;
    if (event.target.id==="idZivBr") {
      setGovedo({...govedo,zivbr:_s})
    } else if (event.target.id==="idIme") {
      setGovedo({...govedo,govedo_ime:_s})
    } else if (event.target.id==="iddatrod") {
      setGovedo({...govedo,datum_rodjenje:_s})
    } else if (event.target.id==="slctSpol") {
      setGovedo({...govedo,spol:_s.toLowerCase()})
    } else if (event.target.id==="iddatrodedit") {
      setGovedo({...govedo,datum_rodjenje:_s})
    } else if (event.target.id==="idMZivBr") {
      setGovedo({...govedo,mzivbr:_s})
    } else if (event.target.id==="idOZivBr") {
      setGovedo({...govedo,ozivbr:_s})
    } else if (event.target.id==="slctPasm") {
      setGovedo({...govedo,pasmina_sifra:_s.toLowerCase()})
    } else if (event.target.id==="idRfid") {
      setGovedo({...govedo,rfid:_s})
    } else if (event.target.id==="idOznPut") {
      setGovedo({...govedo,putnica_oznaka:_s})
    } else if (event.target.id==="idPutSerBr"){
      setGovedo({...govedo,putnica_serbr:_s})
    }
   
    
    
    
  }

  return (
    <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'} mb={'1rem'}>
          <Box display={'flex'} flexDir={'column'} w={'50%'}>
            <FormLabel fontSize={size}>Životni broj</FormLabel>
            <Input focusBorderColor='grunt2.400' size={size} textTransform={'uppercase'} id='idZivBr' isReadOnly={_readonly} variant={'filled'} value={DataFetched?govedo.zivbr:""} onChange={onValueChange}></Input>
          </Box>
          <Box display={'flex'} flexDir={'column'} w={'50%'}>
            <FormLabel fontSize={size}>Ime</FormLabel>
            <Input focusBorderColor='grunt2.400' size={size} textTransform={'uppercase'} maxLength={20} id='idIme' variant={'filled'} isReadOnly={_readonly} defaultValue={DataFetched?govedo.govedo_ime:""} onChange={onValueChange}></Input>
          </Box>
        </Box>
        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'} mb={'1rem'}>
          <Box display={'flex'} flexDir={'column'} w={'50%'}>
            <FormLabel fontSize={size}>Datum rođenja</FormLabel>
            {_readonly?<Input focusBorderColor='grunt2.400' size={size} id='iddatrod' variant={'filled'} isReadOnly={_readonly} defaultValue={DataFetched?new Date(govedo.datum_rodjenje).toLocaleDateString("hr-hr"):""}></Input>:
            <Input focusBorderColor='grunt2.400' onChange={onValueChange} type="date" size={size} id='iddatrodedit' variant={'filled'} isReadOnly={_readonly} value={govedo!==undefined?govedo.datum_rodjenje:"2020-01-01"}></Input>
            }
            
          </Box>
          <Box display={'flex'} flexDir={'column'} w={'50%'}>
              <FormLabel fontSize={size}>Spol</FormLabel>
              {_readonly?<Input focusBorderColor='grunt2.400' size={size} variant={'filled'} isReadOnly={_readonly} value={DataFetched?govedo.spol==='m'?'M':'Ž':""}></Input>:
                <Select focusBorderColor='grunt2.400' size={size} variant={'filled'}  value={govedo===undefined?'m':govedo.spol}  id='slctSpol' onChange={onValueChange} >
                  <option key={'idm'} value='m'>MUŠKO</option>
                  <option key={'idf'} value='f'>ŽENSKO</option>
                </Select>
              }
            </Box>
        </Box>
        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'} mb={'1rem'}>
          <Box display={'flex'} flexDir={'column'} w={'50%'}>
            <FormLabel fontSize={size}>Životni broj majke</FormLabel>
            <Input focusBorderColor='grunt2.400' size={size} textTransform={'uppercase'} id='idMZivBr' isReadOnly={_readonly} variant={'filled'} value={DataFetched?govedo.mzivbr:""} onChange={onValueChange}></Input>
          </Box>
          <Box display={'flex'} flexDir={'column'} w={'50%'}>
            <FormLabel fontSize={size}>Životni broj oca</FormLabel>
            <Input focusBorderColor='grunt2.400' size={size} textTransform={'uppercase'} id='idOZivBr' isReadOnly={_readonly} variant={'filled'} value={DataFetched?govedo.ozivbr:""} onChange={onValueChange}></Input>
          </Box>
        </Box>
        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'} mb={'1rem'}>
             <Box display={'flex'} flexDir={'column'} w={'50%'}>
               <FormLabel fontSize={size}>Pasmina</FormLabel> 
               {_readonly?<Input focusBorderColor='grunt2.400' size={size} id='idPasmina' isReadOnly={_readonly} variant={'filled'} defaultValue={DataFetched?govedo.pasmina_naziv:""}></Input>:
                 DataFetched?<Select focusBorderColor='grunt2.400' size={size} variant={'filled'} value={DataFetched?govedo.pasmina_sifra:null} onChange={onValueChange} id='slctPasm'>
                                 {
                                     pasmine.map((item,i)=>{
                                         return (
                                             <option key={`psm${i}`} value={item.sifra}>{item.naziv}</option>        
                                         )
                                     })
                                     }
                 </Select>:null
              }
            </Box> 
            {/*  {DataFetched && govedo.lokacija!==undefined?
              <Box display={'flex'} flexDir={'column'} w={'50%'}>
                <FormLabel fontSize={size}>Lokacija</FormLabel>
                <Input focusBorderColor='grunt2.400' size={size} id='idLokacija' isReadOnly={true} variant={'filled'} defaultValue={DataFetched?govedo.lokacija:""}></Input>
              </Box>:null
            } */} 
            <Box display={'flex'} flexDir={'column'} w={'50%'}>
              <FormLabel fontSize={size}>RFID</FormLabel>
              <Input focusBorderColor='grunt2.400' size={size} id='idRfid' type="number" isReadOnly={_readonly} variant={'filled'} value={DataFetched?govedo.rfid:""} maxLength={20} onChange={onValueChange}></Input>
            </Box>    
      </Box>
      <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'} mb={'1rem'}>
        <Box display={'flex'} flexDir={'column'} w={'50%'}>
          <FormLabel fontSize={size}>Serijski br. putnice</FormLabel>
          <Input focusBorderColor='grunt2.400' size={size} id='idPutSerBr' isReadOnly={_readonly} variant={'filled'} value={DataFetched?govedo.putnica_serbr:""} maxLength={30} onChange={onValueChange}></Input>
        </Box>
          <Box display={'flex'} flexDir={'column'} w={'50%'}>
            <FormLabel fontSize={size}>Oznaka na putnici</FormLabel>
            <Input focusBorderColor='grunt2.400' size={size} maxLength={9} id='idOznPut' isReadOnly={_readonly} variant={'filled'} value={DataFetched?govedo.putnica_oznaka:""} onChange={onValueChange}></Input>
          </Box>
      </Box>
      {showSaveClose()}
    </Box>
  )
}
